import PropTypes from 'prop-types';
import React from 'react';
import { RoleAllowShop } from '../../../auth/roleAware';

const ResetServicesOrderButton = ({ onButtonClick }) => (
  <RoleAllowShop>
    <button className="c-btn c-btn--ghost c-btn--medium" onClick={onButtonClick} type="button">
      Reset service order
    </button>
  </RoleAllowShop>
);

ResetServicesOrderButton.propTypes = {
  onButtonClick: PropTypes.func.isRequired,
};

export default ResetServicesOrderButton;
